import GenericTopPostsDrawer from './GenericTopPostsDrawer';
import React from 'react';
import { getCategoryBrandRelatedHashtagTopPosts } from 'utils/api/instagram.api';

const RelatedHashtagCategoryBrandDrawer = ({
    year,
    week,
    brands,
    categories,
    hashtags,
    countries,
    name,
    displayQty,
}) => {
    const queryParams = {
        brand: brands || null,
        category: categories || null,
        hashtag: hashtags || null,
        country: countries || null,
        page: 1,
        per_page: 500,
    };

    return (
        <GenericTopPostsDrawer
            year={year}
            week={week}
            name={name}
            displayQty={displayQty}
            queryFn={getCategoryBrandRelatedHashtagTopPosts}
            queryParams={queryParams}
        />
    );
};

export default RelatedHashtagCategoryBrandDrawer;
